// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"VisuallyHidden_visuallyHidden__-RG3u"};